import React from "react";

import styled from "styled-components";
import OpponentCards from "../opponentCards/opponentCards";
import HandCards from "../handCards/handCards";
import CardStack from "../cardStack/cardStack";
import ControlButtonsHidden from "../controlButtons/controlButtonsHidden";
import PlayerControls from "../playerControls/playerControls";
import ScoreBoard from "../scoreBoard/scoreBoard";
import { useStore } from 'react-context-hook';
import SocketContext from '../../socket-context'
import PlayerInfo from "../playerInfo/playerInfo";

const BoardWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    justify-content: space-between;
    padding: 16px;
`;

const ColumnWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

const TopRow = styled.div`
    align-self: center;
`;

const HiddenRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const CardsWrapper = styled.div`
    display: block;
`;

const StackWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 64px;
`;

const PosCombosWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const Label = styled.div`
    font-size: 12px;
    color: dimgray;
`;


const Title = styled.div`
    font-size: 16px;
    color: black;
    font-weight: 500;
    margin-bottom: 8px;
`;

const Number = styled.div`
    font-size: 14px;
    color: black;
    margin-bottom: 4px;
`;

const PredictedCardsWrapper = styled.div`
    margin-top: -110px;
`;

const cardHeight = 120;

const HiddenView = () => {
    const [predictedHandCards] = useStore('predictedHandCards', [[],[],[],[]]);
    const { cards } = predictedHandCards;
    const [game] = useStore('game', {});
    const {cardCounts, handCards, cardStack, possibleCombos} = game;
    return (
        <BoardWrapper>
            <ColumnWrapper>
                {[...Array(4)].map((e, i) => (
                    <HiddenRow>
                        <PlayerInfo player={i} />
                        <CardsWrapper>
                            <HandCards handcards={handCards[i]} cardHeight={cardHeight}/>
                            {cards[i].length > 0 && (
                                <PredictedCardsWrapper>
                                    <HandCards handcards={cards[i]} cardHeight={cardHeight}/>
                                </PredictedCardsWrapper>
                            )}
                        </CardsWrapper>
                    </HiddenRow>
                ))}
            </ColumnWrapper>
            <ColumnWrapper>
                Stack:
                <StackWrapper>
                    <CardStack cards={cardStack} cardHeight={120}/>
                </StackWrapper>
                <PosCombosWrapper>
                    <Title>Possible Hidden Combinations</Title>
                    {[...Array(4)].map((e, i) => (
                        <>
                            <Label>Player {i}</Label>
                            <Number>{possibleCombos[i] > 1000000 ? '> 1M' : possibleCombos[i]}</Number>
                        </>

                    ))}
                </PosCombosWrapper>
            </ColumnWrapper>
            <SocketContext.Consumer>
                {socket => <ControlButtonsHidden socket={socket}/>}
            </SocketContext.Consumer>
        </BoardWrapper>
    );
};

export default HiddenView;